import React from 'react'
import BaseComponent from './BaseComponent'
import Footer from './Footer'
import _ from 'lodash'
import { NavLink } from 'react-router-dom'
import SideNav from './SideNav'
import Modal from './Modal'

export default class GalleryPage extends BaseComponent {

  constructor(props) {

    super(props)
    this.state = { image: 0, popup: false }
    this._bind('showImage', 'closePopup', 'setImage')
  }

  showImage(i) {
    this.setState({ image: i, popup: true })
  }

  setImage(i) {

    if (i >= 0 && i < this.selectedArticle.gallery.length) {
      this.setState({ image: i })
    }
  }

  closePopup() {
    this.setState({ popup: false })
  }

  render() {
  	this.selectedArticle = _.filter(this.props.data.gallery, { slug: this.props.match.params.name })[0]
    if (this.selectedArticle.gallery === null) {
      this.selectedArticle.gallery = []
    }

    let popupInner = (
      <div className="image">
        <div className="close-bg" onClick={ this.closePopup }></div>
        { this.state.image > 0 ? <div className="prev" onClick={ this.setImage.bind(null, this.state.image-1) }></div> : null }
        <div className="close" onClick={ this.closePopup }></div>
        { this.selectedArticle.gallery.length > 0 ? <img src={ this.selectedArticle.gallery[this.state.image] } alt=""/> : null }
        { this.state.image < this.selectedArticle.gallery.length-1 ? <div className="next" onClick={ this.setImage.bind(null, this.state.image+1) }></div> : null }
      </div>
    )

    let gallery = this.selectedArticle.gallery.map((item, i) => {
      return (
        <li key={ i } style={{ backgroundImage: "url(" + item + ")" }} onClick={ this.showImage.bind(null, i) }></li>
      )
    })

    return (
      <section className="article">
      	<ul className="breadcrumbs">
      		<div className="container-big">
	      		<li><NavLink to="/">Strona główna</NavLink></li>
	      		<li><NavLink to="/realizacje">Realizacje</NavLink></li>
	      		<li><NavLink to={ "/realizacje/galeria/" + this.selectedArticle.slug }>{ this.selectedArticle.title }</NavLink></li>
      		</div>
      		<div className="bottom"></div>
      	</ul>
        <div className="outer-container">
          <SideNav data={ this.props.data }/>
        	<div className="container">
        		<div className="image" style={{ backgroundImage: "url(" + this.selectedArticle.image + ")" }}></div>
        		<h1>{ this.selectedArticle.title }</h1>
            <div dangerouslySetInnerHTML={{ __html: this.selectedArticle.description }}></div>
        		<ul className="gallery">
              { gallery }
            </ul>
        	</div>
        </div>
      	<Footer data={ this.props.data } settings={ this.props.data.settings }/>
        <Modal open={ this.state.popup } hidePopup={ this.closePopup } dispatch={ this.dispatch }>{ popupInner }</Modal>
      </section>
    )
  }
}


// WEBPACK FOOTER //
// ./src/app/components/GalleryPage.js